export default "<body-overlay class=\"body-overlay visibility-hidden {{ classes }}\">\n</body-overlay>";